import { render } from "./Heritability.vue?vue&type=template&id=f7a4f5ba&scoped=true"
import script from "./Heritability.vue?vue&type=script&lang=js"
export * from "./Heritability.vue?vue&type=script&lang=js"

import "./Heritability.vue?vue&type=style&index=0&id=f7a4f5ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7a4f5ba"]])

export default __exports__